import * as React from 'react';
import Typography from '@mui/material/Typography';
// import { useNavigate } from "react-router-dom";
// import { Box } from '@mui/system';
import { Grid, Stack } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import DevicesIcon from '@mui/icons-material/Devices';
import GroupsIcon from '@mui/icons-material/Groups';
// import CloseIcon from '@mui/icons-material/Close';

export default function CardComponent({data,title}) {
  
  return (

    <Grid>
      <Typography  sx={{textAlign:'center', fontSize:'50px',fontWeight:'600' }} color="#5B81C5">
        {data?.total_devices}  {data?.total_users} {data?.total_roles} {data?.total_dealers}
      </Typography>
      <Stack sx={{pt:3}} direction="row" alignItems="center" gap={1}>
        <Typography>
        {data?.total_users ? <PersonIcon fontSize='medium'></PersonIcon> : data?.total_dealers ?  <GroupIcon fontSize='medium'></GroupIcon>   : data?.total_devices ? <DevicesIcon fontSize='medium'></DevicesIcon> :  data?.total_roles ? <GroupsIcon fontSize='medium'></GroupsIcon> : ''  }
        </Typography>
        <Typography noWrap  sx={{ fontSize:'16px',fontWeight:'500' }} color='#8D8D8D'>
          {title}
        </Typography>
      </Stack>
    </Grid>
  );
}
